import { createSlice } from '@reduxjs/toolkit';


const initialState = {
  scannedData: [],
  scannedDataOfUser: {},
  todaysSnack: {},
};

const teaAndSnacksSlice = createSlice({
  name: 'teaAndSnacks',
  initialState: initialState,
  reducers: {
    setScannedData: (state, action) => {
      state.scannedData = action.payload;
    },
    setScannedDataOfUser: (state, action) => {
      state.scannedDataOfUser = action.payload;
    },
    setTodaysSnack: (state, action) => {
      state.todaysSnack = action.payload;
    },
  },
});


export const {setScannedData,setScannedDataOfUser,setTodaysSnack,setAttendance} = teaAndSnacksSlice.actions

export const selectScannedData = (state) => state.teaAndSnacks.scannedData
export const selectScannedDataOfUser = (state) => state.teaAndSnacks.scannedDataOfUser 
export const selectTodaysSnack = (state) => state.teaAndSnacks.todaysSnack